export const SupplierTypeEnum = Object.freeze({
  INDIVIDUAL: "INDIVIDUAL",
  COMPANY: "COMPANY",
  GOVERNMENT: "GOVERNMENT",
});
